import { render, staticRenderFns } from "./GestionTurnos.vue?vue&type=template&id=54eaab60&scoped=true"
import script from "./GestionTurnos.vue?vue&type=script&lang=js"
export * from "./GestionTurnos.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnos.vue?vue&type=style&index=0&id=54eaab60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eaab60",
  null
  
)

export default component.exports